<template>
  <div class="mb-6">
    <article class="card">
      <Popper
        v-cloak
        ref="popper"
        v-can="['edit-discussion-replies', 'archive-discussion-replies']"
        class="mr-4 mt-4 float-right"
        trigger="click"
        :options="{}"
      >
        <div class="popper popper-simple popper-arrow">
          <div class="max-w-md flex flex-col">
            <div class="flex flex-col text-left">
              <a
                v-can="'edit-discussion-replies'"
                @click.prevent="editing(true)"
                v-text="'Edit'"
              />
              <a
                v-can="'archive-discussion-replies'"
                @click.prevent="openArchiveReplyModal"
                v-text="'Remove'"
              />
            </div>
          </div>
        </div>
        <button
          slot="reference"
          class="btn btn--sm btn--icon-only icon icon--small"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="9"
            height="15"
            viewBox="0 0 9 15"
          >
            <path d="M7.67 2.48l.66-1.23L6.25.21 5.56 1.5zm-2.35-.54L.48 10.95l2.11.98 4.84-9.01zM.31 11.43L.1 14.11l2.21-1.75z" />
          </svg>
        </button>
      </Popper>
      <div class="card-content mx-auto flex-row">
        <div class="flex-1">
          <div class="flex justify-between">
            <div class="flex flex-1 flex-col sm:flex-row items-center justify-between">
              <div class="flex items-center">
                <img
                  :src="authorAvatar"
                  class="rounded-full mr-4 w-8 h-8"
                  alt=""
                >
                <span v-text="reply.creator.attributes.full_name" />
                <span
                  v-if="creatorRole"
                  class="ml-4 uppercase border border-grey-darker text-grey-darker inline-block px-1 text-xs rounded whitespace-no-wrap"
                  v-text="creatorRole"
                />
              </div>
              <div class="pl-8 text-grey-dark">
                {{ reply.attributes.created_at | calendarTime }}
              </div>
            </div>
          </div>
          <div
            v-if="!isEditing"
            class="pt-4 text-grey-darkest"
          >
            <div
              class="pt-4 text-grey-darkest"
              v-html="reply.attributes.body"
            />
          </div>
          <div
            v-else
            v-can="'edit-discussion-replies'"
            class="pt-4 text-grey-darkest"
          >
            <Redactor
              v-model="body"
              class="input text-lg pb-2"
              :config="redactorConfig"
            />
            <div class="flex justify-between items-center">
              <div>
                <span
                  class="btn"
                  @click="updateReply"
                  v-text="'Update'"
                />
              </div>
              <div class="ml-6">
                <button
                  type="button"
                  @click="editing(false)"
                  v-text="'Cancel'"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script type="text/babel">
import _ from 'lodash'
import { mapActions } from 'vuex'
import Popper from 'vue-popperjs'

export default {
  name: 'DiscussionReply',
  components: {
    Popper,
  },
  props: {
    reply: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isEditing: false,
      body: '',
      redactorConfig: {
        buttons: ['bold', 'italic', 'ul', 'ol', 'link', 'image'],
        imageUpload: this.$urlGenerator.active('api/v1/images/redactor'),
        imageUploadParam: 'images',
        plugins: ['video'],
        minHeight: '300px',
      },
    }
  },
  computed: {
    creatorRole() {
      return this.reply.creator._type === 'User'
        ? 'Super Admin'
        : _.get(this.reply.creator, 'role.attributes.title', false)
    },
    authorAvatar() {
      return this.reply.creator._type === 'User'
        ? this.reply.creator.attributes.avatar.small
        : this.reply.creator.attributes.small_avatar_url
    },
  },
  methods: {
    ...mapActions([
      'discussionUpdateReply',
    ]),
    hidePopper() {
      this.$refs.popper.showPopper = false
    },
    openArchiveReplyModal() {
      this.$store.commit('discussionArchiveReplyModalOpen', this.reply)

      this.hidePopper()
    },
    editing(isEditing) {
      this.isEditing = isEditing
      this.body = isEditing ? this.reply.attributes.body : ''

      this.hidePopper()
    },
    updateReply() {
      if (!this.body.length) {
        return false
      }

      this.discussionUpdateReply({
        replyUuid: this.reply.uuid,
        params: {
          body: this.body,
        },
      }).then(() => {
        this.editing(false)
      })
    },
  },
}
</script>
